<template>
  <div class="g-flex g-row-center">
    <div class="total-width">
      <!-- 考试封面-标题 -->
      <div class="total-card g-m-t-30">
        <div class="g-p-20 g-flex g-col-top">
          <img :src="examDetailData.imgPath" class="test-img" alt="">
          <div class="g-m-l-30 g-m-t-30 g-full-width ">
            <p class="g-font-26 main-text g-weight-font">{{ examDetailData.paperName }}</p>
            <p class="g-m-t-15 remark-text">{{ examDetailData.examNum }}人已考</p>
            <div class="g-m-t-25 blue-tag">
              {{ examDetailData.testLevel }}
            </div>
          </div>
        </div>
      </div>
      <!-- 考试结果状态 -->
      <div class="g-m-t-30">
        <exam-card :examDetailData="examDetailData"></exam-card>
      </div>
    </div>
  </div>
</template>

<script>
import ExamCard from "@/views/examination/components/exam-card";
import {getPaperExam} from "@/api/education/paper";
export default {
  name: "examination-detail",
  components: {ExamCard},
  data(){
    return{
      paperId: this.$route.query.id,
      examDetailData:{}
    }
  },
  created() {
    this.getPaperExamDetail()
  },
  methods:{
    getPaperExamDetail(){
      getPaperExam(this.paperId).then(res=>{
        this.examDetailData=res
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.total-card{
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64,122,255,0.10);

  .test-img{
    width: 215px;
    height: 195px;
    border-radius: 5px;
  }

  .blue-tag{
    background: #1788ff;
    border-radius: 20px;
    padding: 4px 18px;
    color: #fff;
    display: inline-block;
    font-size: 10px;
  }
}
</style>